import './structureReturns.css'

import type { StoreResponse } from 'api/Stores/types'
import { InfoElement } from 'components'
import React from 'react'
import { l4lColumn, storeNameColumnWithL4L } from 'TableCommon/defaultColumns'
import type { Translate } from 'types'
import {
  DEFAULT_CURRENCY,
  formatNumber,
  formatNumberWithCurrency,
  getAmountLabelForNumber,
  getDifferenceWithPrecision,
  getNumberWithCurrency,
  roundDownNumber,
} from 'utils'

import Box from '@mui/material/Box'

import { REVENUE_SORT_COLUMNS } from './constants'

interface Props {
  store: StoreResponse
  t: Translate
}

export default [
  storeNameColumnWithL4L,
  {
    id: REVENUE_SORT_COLUMNS.REVENUE_CURRENT_PLN,
    classNameHeader: 'cell-revenue-current',
    classNameRow: 'cell cell-revenue-current',
    translation: ['rankings.revenueCurrent'],
    RowRenderer: ({ store, t }: Props) => (
      <Box>
        {formatNumberWithCurrency({
          number: store.revenueCurrent,
          translate: t,
        })}
      </Box>
    ),
  },
  {
    id: REVENUE_SORT_COLUMNS.RETURNS,
    classNameHeader: 'cell-returns',
    classNameRow: 'cell cell-returns',
    translation: ['returnsValueDetails.returns'],
    RowRenderer: ({ store, t }: Props) => (
      <Box>
        {getNumberWithCurrency({
          currency: store.currency,
          number: store.returnsValueCurrent,
          precision: 0,
          translate: t,
        })}
      </Box>
    ),
  },
  {
    id: REVENUE_SORT_COLUMNS.RETURNS_SHARE,
    classNameHeader: 'cell-returns-share',
    classNameRow: 'cell cell-returns-share',
    translation: ['returnsValueDetails.returnsValueShareCurrent'],
    RowRenderer: ({ store, t }: Props) => (
      <InfoElement
        percentDifference={getDifferenceWithPrecision({
          handleNullCase: true,
          number: store.returnsValueShareCurrent,
          precision: 0,
          translate: t,
        })}
      />
    ),
  },
  {
    id: REVENUE_SORT_COLUMNS.SALE_WITHOUT_RETURNS,
    classNameHeader: 'cell-sale-without-returns',
    classNameRow: 'cell cell-sale-without-returns',
    translation: ['revenue.details.result.saleWithoutReturns'],
    RowRenderer: ({ store, t }: Props) => {
      const returnsValueFormatted = store.revenueWOReturnsCurrent && formatNumber(roundDownNumber(store.revenueWOReturnsCurrent), t)
      const returnsValueLabel = getAmountLabelForNumber(store.revenueWOReturnsCurrent, t, DEFAULT_CURRENCY)
      const value = store.returnsValueCurrent && store.returnsValueCurrent <= 0 ? returnsValueFormatted : '-'

      return <Box>{`${value} ${returnsValueLabel}`}</Box>
    },
  },
  l4lColumn,
]
